<template>
  <el-dialog
    :modal-append-to-body="false"
    width="1000px"
    top="10vh"
    title="AI分析报告"
    :visible="visible"
    :destroy-on-close="true"
    @close="onClose"
  >
    <div class="drawer-container">
      <!-- 右侧内容区域 -->
      <div class="right-content big">
        <el-card header="基本信息" class="el-card_margin">
          <el-row class="el-row_margin">
            <el-col :span="12" class="el-row_font">
              询价企业: {{ companyName }}
            </el-col>
            <el-col :span="12" class="el-row_font">
              询价单号: {{ businessId }}
            </el-col>
          </el-row>
          <el-row class="el-row_margin">
            <el-col :span="24" class="el-row_font">
              询价单名称: {{ businessName }}
            </el-col>
          </el-row>
        </el-card>
        <template v-if="!globalReminder">
          <el-card style="margin-bottom: 16px" header="询价AI辅助审查结果">
            <template slot="button">
              <div class="ai-warning-tip big">
                <span
                  >AI生成内容仅供参考，不作为决策依据，请以实际业务情况为准</span
                >
              </div>
            </template>
            <div v-for="(info, idx) in section" :key="idx">
              <template v-if="info.advanceArr && info.advanceArr.length > 0">
                <div class="review-point-title">
                  AI审查点{{ idx + 1
                  }}{{ info.classification ? ` - ${info.classification}` : '' }}
                </div>
                <div class="review-point-area">
                  <div class="review-table bg-gray title">问题原文</div>
                  <div class="review-table bg-gray">
                    {{ info.originalText }}
                  </div>
                  <div class="review-table title">AI建议</div>
                  <div class="review-table">
                    <div
                      v-for="advance in info.advanceArr"
                      :key="advance"
                      class="review-advance"
                    >
                      {{ advance }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </el-card>
        </template>
        <template v-else>
          <div class="no-data bg-gray">
            {{ globalReminder }}
          </div>
        </template>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import request from '@/modules/projectA/api/request';

export default {
  name: 'AiDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    businessId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      section: [],
      businessName: '',
      globalReminder: '',
      companyName: '',
      timer: null,
    };
  },
  watch: {
    visible: {
      handler(status) {
        if (status) {
          this.handleDetailsInfo(this.businessId);
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    onClose() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.$emit('update:visible', false);
    },
    handleDetailsInfo(businessId) {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.getReviewAdvanceDetails(businessId);
      this.timer = setInterval(() => {
        this.getReviewAdvanceDetails(businessId);
      }, 10000);
    },
    getReviewAdvanceDetails(businessId) {
      request
        .post('/ai-management/inquiry/ai/reviewAdvance', {
          businessId,
        })
        .then((res) => {
          if (res.code !== '200') return this.$message.error(res.msg);
          const {
            globalReminder = '',
            companyName = '',
            businessName = '',
            reviewStatus = 0,
            result = [],
          } = res.data || {};
          if (reviewStatus) {
            clearInterval(this.timer);
            this.timer = null;
          }
          this.globalReminder = globalReminder;
          this.companyName = companyName;
          this.businessName = businessName;
          this.section = result;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.drawer-container {
  display: flex;
  height: 100%;
  position: relative;
}

.right-content {
  flex: 1;
  padding: 0 16px;
  position: relative;
  overflow-y: auto;
  .bg-gray {
    background-color: #f0f0f0;
  }
  .no-data {
    display: flex;
    justify-content: center;
    height: 500px;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    padding: 0 20px;
  }
  .base-area {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 930px;
    justify-content: end;
    .screen-icon {
      margin-left: 10px;
    }
  }
  .ai-warning-tip {
    display: inline;
    margin: 15px;
    position: relative;
    top: -1px;
    span {
      border: 1px solid #fcb969;
      padding: 2px 6px;
      border-radius: 5px;
      color: #f00;
      background-color: #fed29d;
      font-size: 11px;
    }
  }
  .review-point-title {
    font-size: 16px;
    font-weight: bold;
  }
  .review-point-area {
    margin: 10px 0 25px 0;
    .review-table {
      border: 1px solid rgb(128, 128, 149);
      margin-top: -1px;
      border-collapse: collapse;
      padding: 10px;
      &.title {
        font-size: 14px;
        font-weight: bold;
      }
      .review-advance {
        margin-bottom: 10px;
      }
    }
  }
  .el-card_margin {
    margin-bottom: 15px;
    .el-row_margin {
      margin-bottom: 10px;
      .el-row_font {
        font-size: 12px;
      }
    }
  }
}
::v-deep .el-card__header {
  background-color: #f0f0f0;
}
</style>
